export default (value) => {
	if (!value) return '';
	return value
		.replace(/&nbsp;/g, ' ')
		.replace(/\uFEFF/g, '')
		.trim()
		.replaceAll(/<.*?>/g, '')
		.replaceAll(/[^\u0000-\u007F]+/g, '')
		.replaceAll('&amp;', '&')
		.replaceAll('&lt;', '<')
		.replaceAll('&gt;', '>');
};
